import { render, staticRenderFns } from "./campaigns-list-page.vue?vue&type=template&id=9c115bf6&"
import script from "./campaigns-list-page.vue?vue&type=script&lang=js&"
export * from "./campaigns-list-page.vue?vue&type=script&lang=js&"
import style0 from "./campaigns-list-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports